import React from 'react';
import { Card, CardContent } from '../components/ui/card';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen pt-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="container mx-auto px-4 lg:px-8 py-20">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            Privacy <span className="text-[#0E6E6E]">Policy</span>
          </h1>
          <p className="text-lg text-gray-600 mb-12">
            Last Updated: December 2025
          </p>

          <Card className="mb-8">
            <CardContent className="p-8 space-y-6">
              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Introduction</h2>
                <p className="text-base text-gray-700 leading-relaxed">
                  WealthOptimizers ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our services as an AMFI-registered mutual fund distributor.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Information We Collect</h2>
                <p className="text-base text-gray-700 leading-relaxed mb-3">
                  We collect information that you provide directly to us, including:
                </p>
                <ul className="list-disc list-inside space-y-2 text-base text-gray-700 ml-4">
                  <li>Personal identification information (name, date of birth, address, contact details)</li>
                  <li>Financial information (income, investment history, risk profile)</li>
                  <li>KYC documents (PAN, Aadhaar, bank details, photograph)</li>
                  <li>Investment preferences and goals</li>
                  <li>Communication records (emails, calls, messages)</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">3. How We Use Your Information</h2>
                <p className="text-base text-gray-700 leading-relaxed mb-3">
                  We use the information we collect to:
                </p>
                <ul className="list-disc list-inside space-y-2 text-base text-gray-700 ml-4">
                  <li>Provide investment advisory and mutual fund distribution services</li>
                  <li>Complete KYC compliance as per SEBI regulations</li>
                  <li>Process investment transactions and maintain records</li>
                  <li>Conduct risk profiling and asset allocation</li>
                  <li>Send portfolio updates and market insights</li>
                  <li>Comply with regulatory and legal requirements</li>
                  <li>Improve our services and client experience</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Information Sharing and Disclosure</h2>
                <p className="text-base text-gray-700 leading-relaxed mb-3">
                  We may share your information with:
                </p>
                <ul className="list-disc list-inside space-y-2 text-base text-gray-700 ml-4">
                  <li>Asset Management Companies (AMCs) for processing investments</li>
                  <li>KYC Registration Agencies (KRAs) for KYC compliance</li>
                  <li>Registrars and Transfer Agents (RTAs) for transaction processing</li>
                  <li>SEBI, AMFI, and other regulatory authorities as required by law</li>
                  <li>Insurance companies for insurance-related services</li>
                  <li>Service providers who assist in our operations (with strict confidentiality agreements)</li>
                </ul>
                <p className="text-base text-gray-700 leading-relaxed mt-3">
                  We do not sell, rent, or trade your personal information to third parties for marketing purposes.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Data Security</h2>
                <p className="text-base text-gray-700 leading-relaxed">
                  We implement appropriate technical and organizational security measures to protect your information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Data Retention</h2>
                <p className="text-base text-gray-700 leading-relaxed">
                  We retain your information for as long as necessary to provide our services and as required by applicable laws and regulations. Investment and transaction records are maintained as per SEBI guidelines.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Your Rights</h2>
                <p className="text-base text-gray-700 leading-relaxed mb-3">
                  You have the right to:
                </p>
                <ul className="list-disc list-inside space-y-2 text-base text-gray-700 ml-4">
                  <li>Access your personal information we hold</li>
                  <li>Request correction of inaccurate information</li>
                  <li>Request deletion of your information (subject to regulatory requirements)</li>
                  <li>Opt-out of marketing communications</li>
                  <li>Withdraw consent for data processing (where applicable)</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Cookies and Tracking</h2>
                <p className="text-base text-gray-700 leading-relaxed">
                  Our website may use cookies and similar tracking technologies to enhance user experience. You can control cookie preferences through your browser settings.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Third-Party Links</h2>
                <p className="text-base text-gray-700 leading-relaxed">
                  Our website may contain links to third-party websites. We are not responsible for the privacy practices of these external sites. We encourage you to read their privacy policies.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Changes to This Policy</h2>
                <p className="text-base text-gray-700 leading-relaxed">
                  We may update this Privacy Policy from time to time. The updated version will be posted on our website with the "Last Updated" date. We encourage you to review this policy periodically.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Contact Us</h2>
                <p className="text-base text-gray-700 leading-relaxed">
                  If you have questions about this Privacy Policy or wish to exercise your rights, please contact us at:
                </p>
                <p className="text-base text-gray-700 mt-3">
                  Email: Gauravsoni@wealthoptimizers.com<br />
                  We will respond to your inquiry within 30 days.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Regulatory Compliance</h2>
                <p className="text-base text-gray-700 leading-relaxed">
                  As an AMFI-registered mutual fund distributor (ARN-XXXXX), we comply with all applicable SEBI regulations, AMFI guidelines, and data protection laws in India.
                </p>
              </section>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
